import Layout from '../../components/common/pageLayout'
import Header from '../../components/PlanApproval/PlanDetails/header'
import Filter from '../../components/PlanApproval/PlanDetails/filter'
import './planApproval.css'
import Comments from '../../components/PlanApproval/PlanDetails/comments'
import Log from '../../components/PlanApproval/PlanDetails/log'
import { useEffect, useState } from 'react'
import { v3_add_planApproval_comment, v3_plan_approval_comment_change_favourite_status, v3_plan_approval_comment_status_update, v3_planApproval_detail, v3_update_planApproval_assignee } from '../../actions/v3/planApproval'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { toast } from 'react-toastify'
import Reply from '../../components/PlanApproval/PlanDetails/reply'
import constant from '../../constant'

const Detail = () => {

    const location = useLocation();
    const { planId, projectId, projectName, planName, page } = location.state || {};
    const [data, setData] = useState(null)

    const [refresh, setRefresh] = useState(false)

    const [selectedRevision, setSelectedRevision] = useState(null);
    const [selectedComment, setSelectedComment] = useState(null);
    const [activeTab, setActiveTab] = useState('log');
    const [filterPayload, setFilterPayload] = useState({})

    useEffect(() => {
        v3_planApproval_detail(planId, btoa(JSON.stringify(filterPayload))).then((res) => {
            if (res.status) {
                setData(res.result)
            }
        })
    }, [refresh, filterPayload])

    useEffect(() => {
        if (!data?.revisions || data.revisions.length === 0) return;

        // If revisionId exists in filterPayload, select that revision
        if (filterPayload?.revisionId) {
            const matchingRevision = data.revisions.find(
                rev => String(rev.ID) === String(filterPayload.revisionId)
            );
            if (matchingRevision) {
                setSelectedRevision(matchingRevision);
                return;
            }
        }

        // Fallback: select the latest revision
        setSelectedRevision(data.revisions[data.revisions.length - 1]);
    }, [data, filterPayload]);



    const saveAssignee = (userArray) => {
        v3_update_planApproval_assignee({ userArray, planId }).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                setRefresh(!refresh)
                const modal = window.bootstrap.Modal.getInstance(document.getElementById(`assigneeModal-${data.ID}`));
                if (modal) modal.hide();
            }
        })
    }

    const onAddComment = async (payload) => {
        try {
            const res = await v3_add_planApproval_comment({ ...payload, planId });
            if (res.status) {
                toast.success(res.result.message);
                setRefresh(!refresh);

                const modal = window.bootstrap.Modal.getInstance(
                    document.getElementById("commentModal")
                );
                if (modal) modal.hide();

                return true; // ✅ return true on success
            }
            return false; // ❌ in case status is false
        } catch (error) {
            console.error("Error adding comment:", error);
            return false; // ❌ error case
        }
    };
    const onChangeFavouriteStatus = (payload) => {
        v3_plan_approval_comment_change_favourite_status({ ...payload, planId }).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                setRefresh(!refresh)
            }
        })
    }
    const onChangeFilter = (filterModel) => {
        setFilterPayload(filterModel)
    }

    const onChangeCommentStatus = async (model) => {
        v3_plan_approval_comment_status_update(model).then(res => {
            if (res.status) {
                setRefresh(!refresh)
                toast.success(res.result.message)
                const modal = window.bootstrap.Modal.getInstance(document.getElementById(`statusUpdateModal-${model.commentId}`));
                if (modal) modal.hide();
            }
            else {
                toast.error(res.error || res.error.message)

            }
        })
    }
    return (
        <Layout title={`${planName}`}
            titleLink={{
                pathname: constant.Authedcomponent.planApprovalProject.url,
                state: {
                    oldPage: page,
                    projectId,
                    projectName,

                }
            }}
        >
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" >
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12 ">
                                    {data && <Header
                                        data={data}
                                        saveAssignee={saveAssignee}
                                        revision={selectedRevision}
                                        revisions={data?.revisions}
                                    />}
                                    <Filter
                                        statusCount={data?.commentStatusCounts}
                                        onChangeFilter={onChangeFilter}
                                        revisions={data?.revisions || []}
                                        contributor={data?.contributor || []}

                                    />

                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 ">
                                    <div className="Plan-details-report">
                                        <div className="row">
                                            <div className="col-md-7">

                                                {data && <Comments
                                                    selectComment={setSelectedComment}
                                                    data={selectedRevision}
                                                    onUpdateStatus={onChangeCommentStatus}
                                                    onAddComment={onAddComment}
                                                    onChangeFavouriteStatus={onChangeFavouriteStatus}
                                                />}
                                            </div>
                                            <div className="col-md-5">
                                                <div className="widget">
                                                    <div className="widget-content">
                                                        <div className="column-wrap">
                                                            <div className="coloumn">
                                                                <div className="activity">
                                                                    <div className="d-flex gap-3 align-items-center mb-3">
                                                                        <h3
                                                                            className={`mb-0 ${activeTab === 'log' ? 'active' : ''}`}
                                                                            onClick={() => setActiveTab('log')}
                                                                        >
                                                                            Activity Log
                                                                        </h3>

                                                                        {selectedComment && (
                                                                            <h3
                                                                                className={`mb-0 ${activeTab === 'replies' ? 'active' : ''}`}
                                                                                onClick={() => setActiveTab('replies')}
                                                                            >
                                                                                Replies
                                                                            </h3>
                                                                        )}
                                                                    </div>
                                                                    {activeTab === 'log' && <Log
                                                                        planId={planId}
                                                                    />}

                                                                    {activeTab === 'replies' && < Reply
                                                                        planId={planId}
                                                                        commentId={selectedComment}
                                                                        revisionId={selectedRevision?.ID}

                                                                    />}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Layout>

    )
}

export default Detail